<template>
  <v-footer app color="grey-lighten-1" class="text-center d-flex flex-column" padless>
    <v-divider></v-divider>
    <div class="pt-2 pb-2">
      {{ new Date().getFullYear() }} — <strong>Dental Portal</strong>
    </div>
  </v-footer>
</template>

<script>
export default {
  name: 'FooterComponent',
};
</script>
